const planning = [
    {
        id: "wdc001",
        title: "Version Control (GIT)"
    },
    {
        id: "wdc002",
        title: "Gitlab"
    },
    {
        id: "wdc003",
        title: "Github"
    },
    {
        id: "wdc004",
        title: "Wireframing"
    },
    {
        id: "wdc005",
        title: "Prototyping"
    },
    {
        id: "wdc006",
        title: "Mocha & chai"
    },
    {
        id: "wdc007",
        title: "Atlassian Jira"
    },
    {
        id: "wdc008",
        title: "GitKraken"
    },
]

export default planning;
